var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    id: "svg_1",
    d: "m8.612,22.397c0.072,1.537 -0.143,3.65 -2.29,4.637l0.178,0.956c2.897,0 6.099,-1.922 7.332,-5.158l-5.22,-0.435z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ffffff",
    id: "svg_2",
    r: 0.5,
    cy: 27.5,
    cx: 6.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    id: "svg_3",
    d: "m24,4l-18,0c-2.209,0 -4,1.791 -4,4l0,12c0,2.209 1.791,4 4,4l18,0c2.209,0 4,-1.791 4,-4l0,-12c0,-2.209 -1.791,-4 -4,-4zm-9,12c-1.105,0 -2,-0.895 -2,-2c0,-1.105 0.895,-2 2,-2s2,0.895 2,2c0,1.105 -0.895,2 -2,2zm6,0c-1.105,0 -2,-0.895 -2,-2c0,-1.105 0.895,-2 2,-2s2,0.895 2,2c0,1.105 -0.895,2 -2,2zm-12,0c-1.105,0 -2,-0.895 -2,-2c0,-1.105 0.895,-2 2,-2s2,0.895 2,2c0,1.105 -0.895,2 -2,2z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.c2e0a689c5d3215335988b0ec84b29ac.svg";
export { ForwardRef as ReactComponent };